import { useState } from 'react';

const REPOS = ['sidwellgrav/conductor', 'sidwellgrav/biltyn'];

function repoShortName(repo: string): string {
  return repo.split('/')[1] ?? repo;
}

interface RunAuditControlProps {
  auditor: 'cto' | 'ciso';
}

export default function RunAuditControl({ auditor }: RunAuditControlProps) {
  const [pickerRepo, setPickerRepo] = useState(REPOS[0]);
  const [copied, setCopied] = useState(false);

  function copyCommand() {
    const cmd = `run_audit(auditor:"${auditor}", repo:"${pickerRepo}")`;
    navigator.clipboard?.writeText(cmd);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <div className="section">
      <h3>Run audit</h3>
      <div className="badge-row" style={{ flexWrap: 'wrap' }}>
        <select
          className="btn-outline-conductor"
          value={pickerRepo}
          onChange={(e) => setPickerRepo(e.target.value)}
        >
          {REPOS.map((r) => (
            <option key={r} value={r}>{repoShortName(r)}</option>
          ))}
        </select>
        <button className="btn-conductor" disabled title="No HTTP trigger — use the MCP tool below">
          Run audit
        </button>
      </div>
      <div className="card-sub" style={{ whiteSpace: 'normal', marginTop: 6 }}>
        Run via MCP: <span className="code">run_audit(auditor:&quot;{auditor}&quot;, repo:&quot;{pickerRepo}&quot;)</span>{' '}
        <button className="btn-outline-conductor" onClick={copyCommand} style={{ marginLeft: 6 }}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
